import { MetricField } from "../../gql-generated/types";

export interface LensStatsItem {
    label: string;
    tooltip: string;
    value: string;
}

export type LensStatsModel = Partial<Record<MetricField, LensStatsItem>>;

export const lensStatsModel: LensStatsModel = {
    [MetricField.LensViews]: {
        label: "Lens Views",
        tooltip: "The number of times this Lens has been viewed.",
        value: "-",
    },
    [MetricField.LensPlays]: {
        label: "Lens Plays",
        tooltip: "The number of times your Lens has been activated in the camera in Snapchat.",
        value: "-",
    },
    [MetricField.LensShares]: {
        label: "Lens Shares",
        tooltip: "The number of times this Lens has been shared on Snapchat.",
        value: "-",
    },
};
